/* eslint-disable @typescript-eslint/no-explicit-any */
import { Modal } from '@marriott/mi-ui-library';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { StyledFaqModalWrapper } from './AwpFaqAccordionWrapper.styles';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AccordionContainerEnhanced } from '@marriott/mi-common-static-components';
import { earnRedeemStore } from '../../modules/store/earnRedeemStore';
import { AwpFAQAccordionWrapperProps } from './AwpFaqAccordionWrapper.types';
const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const AwpFaqAccordionWrapper = (props: AwpFAQAccordionWrapperProps) => {
  const setShowFaqModal = earnRedeemStore((state: earnRedeemStore) => state?.setShowFaqModal);
  const showFaqModal = earnRedeemStore((state: earnRedeemStore) => state?.showFaqModal) || false;
  const faqModelHeader = earnRedeemStore((state: earnRedeemStore) => state?.faqModelHeader);
  const modelprop = props?.cqItems
    ? props?.cqItems?.['card-0']?.[':items']?.accordioncontainerenhanced
    : props?.[':items']?.['card-0']?.[':items']?.accordioncontainerenhanced;

  const updatedProp = Object.assign({}, modelprop, {
    cqItems: modelprop?.[':items'],
    cqItemsOrder: modelprop?.[':itemsOrder'],
  });

  return showFaqModal ? (
    <StyledFaqModalWrapper data-component-name="m-awp-AwpFaqAccordionWrapper" data-testid="awp-AwpFaqAccordionWrapper">
      <Modal
        show={showFaqModal}
        handleBlur={true}
        popupOpenState={showFaqModal}
        allFilterPopUp={true}
        onClose={(): void => {
          setShowFaqModal(false);
        }}
      >
        <Modal.Header
          className="modal-header t-subtitle-xl modal-accordion-header"
          labelText={faqModelHeader}
          popupHeaderOnCLoseFunc={(): void => {
            setShowFaqModal(false);
          }}
        />

        <Modal.Body className="accordion-body custom-scrollbar">
          <AccordionContainerEnhanced model={updatedProp} allowedComponents={props?.allowedComponents} />
        </Modal.Body>
      </Modal>
    </StyledFaqModalWrapper>
  ) : null;
};

export const AwpFAQAccordionWrapperConfig = {
  emptyLabel: 'AwpFAQAccordionWrapper',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/awpaccordionenhanced`,
};

export const AwpFAQAccordionWrapperEditable = (props: any) => (
  <EditableComponent config={AwpFAQAccordionWrapperConfig} {...props}>
    <AwpFaqAccordionWrapper {...props} />
  </EditableComponent>
);
